import classNames from 'classnames'
import { memo, useEffect, useRef, useState } from 'react'

const _FixedHeight = ({ height = 200, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [notApply, setNotApply] = useState(false)
  const contentRef = useRef(null)

  const toggleCollapse = () => setIsCollapsed(prev => !prev)
  const classes = classNames('fixed-height-content', { 'fixed-heigh-mask': isCollapsed })

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.offsetHeight
      if (contentHeight <= height) {
        setNotApply(true)
      }
    }
  }, [height])

  if (notApply) return children

  return (
    <div className="fixed-height-container">
      <div
        className={classes}
        style={isCollapsed ? { height: `${height}px` } : { height: 'fit-content' }}
      >
        <div ref={contentRef}>{children}</div>
      </div>
      <button className="fixed-height-show" onClick={toggleCollapse}>
        {isCollapsed ? 'Show more' : 'Show less'}
      </button>
    </div>
  )
}

export const FixedHeight = memo(_FixedHeight)
